import produce, { Draft, enableES5 } from 'immer';
import * as AuthAction from 'src/authentication/models/action';
import { placActionNames } from '../actions/actionNames';
import { PlacActionTypes } from '../actions/actions';
import { Controls } from '../models/store';

enableES5();

const initState = {
  userCredits: {},
  fileName: null,
  scanID: null,
};

export const controlReducer = produce((draft: Draft<Controls>, action: any) => {
  switch (action.type) {
    case placActionNames.SET_USER_CREDITS:
      draft.userCredits = action.userCredits;
      break;
    case placActionNames.USER_UPLOADED_FILE:
      draft.fileName = action.fileName;
      break;
    case placActionNames.SYSTEM_GENERATED_SCAN_ID:
      draft.scanID = action.scanID;
      break;
    case AuthAction.LOGOUT_USER:
      draft.userCredits = {} as any;
      break;
    default:
      break;
  }
}, initState);
